import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import "./commonSlider.scss";

import Slider, { Settings } from 'react-slick';

import React from "react";

type CommonSliderProps = {
    sliderRef : React.RefObject<Slider>;
    component: React.ReactNode[];
} & Settings

export const CommonSlider: React.FC<CommonSliderProps> = (props) => {
    const { sliderRef, slidesToShow, component, className, infinite, dots, arrows, autoplay,
        autoplaySpeed  } = props;

    const settings: Settings = {
        autoplay: autoplay,
        autoplaySpeed: autoplaySpeed,
        dots: dots,
        infinite: typeof infinite === 'boolean' ? infinite : dots,
        speed: 500,
        slidesToShow: slidesToShow,
        slidesToScroll: slidesToShow,
        arrows: arrows,
        pauseOnHover: true,
        pauseOnFocus: true,
        pauseOnDotsHover: false,

        afterChange: () => {
            if (document.activeElement instanceof HTMLElement) {
                document.activeElement.blur();
            }
        },
        responsive: [
            {
                breakpoint: 1024,
                settings: {
                slidesToShow,
                slidesToScroll: 1,
                },
            },
            {
                breakpoint: 768,
                settings: {
                slidesToShow,
                slidesToScroll: 1,
                },
            },
        ],
    };
    
    return (
        <div className="common-slider">
            <Slider className={className} ref={sliderRef} {...settings}>
                {component.map((comp)=>comp)}
            </Slider>
        </div>
    );
} 